module.exports = __webpack_public_path__ + "img/login_drawing.dfa03c58.svg";